import { useEffect, useState } from "react";

// Single source of truth for the mobile breakpoint (Tailwind `md`). Reactive to resize/rotate.
// Desktop & tablets with room keep the inline popover; phones get the mobile-safe sheet picker.
const QUERY = "(max-width: 767px)";

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== "undefined" && window.matchMedia(QUERY).matches,
  );
  useEffect(() => {
    const mq = window.matchMedia(QUERY);
    const onChange = () => setIsMobile(mq.matches);
    onChange();
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);
  return isMobile;
}
